export default (state) => state.authentication.refreshToken
